import { createStore } from 'zustand';

export type PasswordRecoveryState = {
  recoveryEmail: string;
};

export const passwordRecoveryStore = createStore<PasswordRecoveryState>(() => {
  return {
    recoveryEmail: '',
  };
});

export const setRecoveryEmail = (email: string) => {
  passwordRecoveryStore.setState({ recoveryEmail: email });
};

export const resetPasswordRecovery = () => {
  passwordRecoveryStore.setState(passwordRecoveryStore.getInitialState(), true);
};
